import * as yup from "yup";

export const loginSchema = yup.object().shape({
  email: yup.string().email().required("Ingrese su correo"),
  password: yup.string().required("Ingrese su contraseña"),
});
